<template>
  <div>
    <span>
      {{ $t('account') }}
      <a-icon type="down" class="icon" />
    </span>
    <ul>
      <header-link
        v-for="link in accountLinks"
        :key="link.to"
        :to="link.to"
        :label="link.label"
        class="account-link"
      />
    </ul>
  </div>
</template>

<script>
import HeaderLink from '@/components/header/Link.vue';
import { ROUTER_PATHS } from '@/router/constants';

export default {
  components: {
    HeaderLink,
  },
  data() {
    return {
      accountLinks: [
        {
          to: ROUTER_PATHS.TARGETING_INFO,
          label: this.$t('targeting.info'),
        },
        {
          to: ROUTER_PATHS.PRIVATE_INFO,
          label: this.$t('private.info'),
        },
        {
          to: ROUTER_PATHS.DIGITAL_FINGERPRINT,
          label: this.$t('digital.fingerprint'),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.icon {
  font-size: 13px;
}

.account-link {
  margin: 0;
  padding: 0 0 20px 20px;
  text-transform: capitalize;
}

.account-link:first-of-type {
  padding-top: 20px;
}
</style>
